export interface UnsplashPhoto {
  artistName: string;
  blurHash: string;
  color: string;
  description: string;
  alt_description?: string;
  downloadLocation: string;
  height: number;
  id: string;
  unsplashProfile: string;
  urlFull: string;
  urlRaw: string;
  width: number;
  tags?: string[];
  tags_preview?: {
    title: string;
    type: string;
  }[];
  objectName?: string;
  preview?: string;
  asset_type?: string;
  urls?: {
    full: string;
  };
  user?: {
    name: string;
    links?: {
      html: string;
    };
  };
  links?: {
    download_location: string;
  };
}

// UnsplashPhotoRaw type that returns from unsplash api
export interface UnsplashPhotoRaw {
  id: string;
  width: number;
  height: number;
  description: string;
  color: string;
  blur_hash: string;
  urls: {
    raw: string;
    full: string;
  };
  links: {
    download_location: string;
  };
  user: {
    name: string;
    username: string;
  };
  tags: string[];
  alt_description?: string;
}

// Unsplash username prefix
export const UNSPLASH_USERNAME_PREFIX = 'https://unsplash.com/@';

// Convert UnsplashPhotoRaw type to UnsplashPhoto type
export const convertUnsplashPhotoDetailed = (
  result: UnsplashPhotoRaw
): UnsplashPhoto => ({
  id: result.id,
  width: result.width,
  height: result.height,
  description: result.description,
  color: result.color,
  blurHash: result.blur_hash,
  urlRaw: result.urls.raw,
  urlFull: result.urls.full,
  downloadLocation: result.links.download_location,
  artistName: result.user.name,
  unsplashProfile: UNSPLASH_USERNAME_PREFIX + result.user.username,
  tags: result.tags,
  alt_description: result.alt_description,
});
